const VALIDATOR_OPERATOR_ROLE_IDS = ['las:role:supervise-operator', 'las:role:validator'];

export function hasValidatorRole(roles: string[]) {
  return roles.some((role) => VALIDATOR_OPERATOR_ROLE_IDS.includes(role));
}
